export default "__VITE_ASSET__DCGd0aF0__"